<template>
  <svg width="11" height="5" viewBox="0 0 11 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0668 0.822392C10.306 0.684251 10.612 0.76623 10.7501 1.0055C10.8882 1.24459 10.8064 1.55032 10.5675 1.6886L5.83223 4.4289L5.54268 4.26173C5.39489 4.1764 5.30384 4.01871 5.30384 3.84805C5.30385 3.67739 5.39489 3.5197 5.54268 3.43437L10.0668 0.822392Z"
      fill="white"
    />
    <path
      d="M1.08536 1.68829C0.84621 1.55022 0.764273 1.24443 0.902344 1.00528C1.04041 0.766134 1.34621 0.684197 1.58536 0.822268L6.10826 3.43357C6.25692 3.5194 6.3485 3.67801 6.3485 3.84967C6.3485 4.01959 6.25875 4.17687 6.11246 4.26332L5.83223 4.4289L1.08536 1.68829Z"
      fill="white"
    />
  </svg>
</template>
